var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive pca-table",style:({ '--border-color': _vm.borderColor })},[_c('table',{class:['table', _vm.tableClass],style:(_vm.tableStyle)},[_c('thead',{class:_vm.theadClass},[_c('tr',[_vm._t("thead")],2)]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }